import { render, staticRenderFns } from "./FooterElement.vue?vue&type=template&id=6adc3326&scoped=true&"
var script = {}
import style0 from "./FooterElement.vue?vue&type=style&index=0&id=6adc3326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc3326",
  null
  
)

export default component.exports